import { render, staticRenderFns } from "./tit-form-section.vue?vue&type=template&id=65c985d0&"
import script from "./tit-form-section.vue?vue&type=script&lang=js&"
export * from "./tit-form-section.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports